/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core API-EXT Release 1.0.0.alpha
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }  from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../_helpers/appconfig.service';
import { ImportFileOptions } from '../sharedcomp/constans/importProcess.constans';
import { ConfigurationImportProcess, ConfigurationList, Configuration } from '../_models/index';
import { CustomDesignOptions } from '../sharedcomp/constans/customDesign.constans';
@Injectable()
export class ConfigurationService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;

    constructor(protected httpClient: HttpClient) {
        this.httpOptions = {
            headers: new HttpHeaders({

                'Content-Type': 'application/json'
            })
        };

    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * create_configuration
     * Create a Configuration
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createConfiguration(body: Configuration, observe?: 'body', reportProgress?: boolean): Observable<Configuration>;
    public createConfiguration(body: Configuration, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Configuration>>;
    public createConfiguration(body: Configuration, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Configuration>>;
    public createConfiguration(body: Configuration, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createConfiguration.');
        }

        let headers = new HttpHeaders().set('Content-Type', 'application/json');


        return this.httpClient.post<Configuration>(`${this._kcmssvcURL}/configurations`,
            body,
            {
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get_configuration
     * Get a Configuration
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConfiguration(publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Configuration>;
    public getConfiguration(publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Configuration>>;
    public getConfiguration(publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Configuration>>;
    public getConfiguration(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getConfiguration.');
        }

        let headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.httpClient.get<Configuration>(`${this._kcmssvcURL}/configurations/${encodeURIComponent(String(publicId))}`,
            {
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get_configuration_list
     * Get Configuration List
     * @param customerId
     * @param object
     * @param type
     * @param name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConfigurationList(customerId: string, object?: string, type?: string, name?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getConfigurationList(customerId: string, object?: string, type?: string, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getConfigurationList(customerId: string, object?: string, type?: string, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getConfigurationList(customerId: string, object?: string, type?: string, name?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getConfigurationList.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (customerId !== undefined && customerId !== null) {
            queryParameters = queryParameters.set('customer_id', <any>customerId);
        }
        if (object !== undefined && object !== null) {
            queryParameters = queryParameters.set('object', <any>object);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.httpClient.get<Array<ConfigurationList>>(`${this._kcmssvcURL}/configurations`,
            {
                params: queryParameters,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
       * update_configuration
       * Update a Configuration
       * @param publicId
       * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
       * @param reportProgress flag to report request and response progress.
       */
    public updateConfiguration(body: Configuration, publicId: string, observe?: 'body', reportProgress?: boolean): Observable<Configuration>;
    public updateConfiguration(body: Configuration, publicId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Configuration>>;
    public updateConfiguration(body: Configuration, publicId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Configuration>>;
    public updateConfiguration(body: Configuration, publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling updateConfiguration.');
        }

        let headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.httpClient.patch<Configuration>(`${this._kcmssvcURL}/configurations/${encodeURIComponent(String(publicId))}`,
            body,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public getCustomerCompaniesList(public_id?: string): Observable<any> {
        return this.httpClient.get(`${this._kcmssvcURL}/configurations?customer_id=` + public_id + `&key=corporate.companies`)
            .pipe(map(res => res)
            );
    }//end

    public getImportConfiguration(publicId: string, url: string): Observable<ConfigurationImportProcess> {
        if (publicId == null) {
            throw new Error('Required parameter publicId was null or undefined when calling the payout invoice importation configuration details.');
        }
        return this.httpClient.get<ConfigurationImportProcess>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/${url}`);
    }

    public getImportConfigurationCustomer(publicId: string, url: string): Observable<ConfigurationImportProcess> {
        if (publicId == null) {
            throw new Error('Required parameter publicId was null or undefined when calling the payout invoice importation configuration details.');
        }
        return this.httpClient.get<ConfigurationImportProcess>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/${url}`);
    }

    public getCustomDesignConfiguration<T = any>(publicId: string, url: (typeof CustomDesignOptions)[keyof typeof CustomDesignOptions]): Observable<Configuration<T>> {
        if (publicId == null) {
            throw new Error('Required parameter publicId was null or undefined when calling the custom design configuration details.');
        }
        return this.httpClient.get<Configuration<T>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/${url}`);
    }

    public getNotificationRestrictionConfig(): Observable<any> {
        return this.httpClient.get<any>(
            `${this._kcmssvcURL}/value-types/notification.restriction_configurations/configurations/configuration`,
            this.httpOptions
        );
    }

    public getNotificationRestrictionConfigByCustomer(customerId: string): Observable<any> {
        return this.httpClient.get<any>(
            `${this._kcmssvcURL}/customers/${encodeURIComponent(customerId)}/configurations/notification.allow_days_and_exclude_holiday`,
            this.httpOptions
        );
    }

}
